import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { fadeUp, stagger } from "@/lib/motion";
import {
  Brain,
  Heart,
  Sparkles,
  Users,
  UtensilsCrossed,
  LifeBuoy,
  Flame,
  MessageCircle,
  GraduationCap,
  HeartHandshake,
  Sprout,
  ArrowUpRight,
} from "lucide-react";

const services = [
  {
    icon: Brain,
    title: "Άγχος & Κρίσεις Πανικού",
    desc: "Διαχείριση γενικευμένου άγχους, κρίσεων πανικού και επαναλαμβανόμενων ανησυχιών, με τεχνικές που βοηθούν να ξαναβρείς ηρεμία και έλεγχο.",
    span: "md:col-span-12 lg:col-span-7",
    big: true,
    img: "https://customer-assets.emergentagent.com/job_therapy-anna-gr/artifacts/ktcjoeh1_IMG_7563.jpeg",
  },
  {
    icon: MessageCircle,
    title: "Κοινωνικό Άγχος",
    desc: "Κατανόηση και διαχείριση του φόβου έκθεσης, της αμηχανίας και της αρνητικής αξιολόγησης από τους άλλους — με πρακτικά εργαλεία για μεγαλύτερη αυτοπεποίθηση στην καθημερινότητα.",
    span: "md:col-span-12 lg:col-span-5",
    link: "/ipiresies/psixologos-patra-koinoniko-agxos",
  },
  {
    icon: Flame,
    title: "Στρες & Burnout",
    desc: "Διαχείριση της καθημερινής πίεσης, της υπερκόπωσης και της συναισθηματικής εξάντλησης, με στόχο την αποκατάσταση της ισορροπίας και της λειτουργικότητας.",
    span: "md:col-span-12 lg:col-span-5",
    link: "/ipiresies/psixologos-patra-burnout",
  },
  {
    icon: Sparkles,
    title: "Ιδεοψυχαναγκαστική Διαταραχή (OCD)",
    desc: "Εξειδικευμένη προσέγγιση για την κατανόηση και διαχείριση των ιδεοληψιών και των καταναγκαστικών μοτίβων.",
    span: "md:col-span-12 lg:col-span-7",
    link: "/ipiresies/psixologos-patra-ocd",
  },
  {
    icon: LifeBuoy,
    title: "Τραύμα & Δύσκολες Εμπειρίες",
    desc: "Υποστήριξη στην επεξεργασία τραυματικών εμπειριών, απώλειας και έντονων συναισθημάτων, μέσα σε ένα ασφαλές, σταθερό θεραπευτικό πλαίσιο και με σεβασμό στον προσωπικό σου ρυθμό.",
    span: "md:col-span-12 lg:col-span-6",
    link: "/ipiresies/psixologos-patra-trauma",
  },
  {
    icon: UtensilsCrossed,
    title: "Συναισθηματική Υπερφαγία",
    desc: "Αποκατάσταση μιας υγιούς, ήρεμης σχέσης με το φαγητό και το σώμα — χωρίς αυτοκριτική και ενοχές.",
    span: "md:col-span-12 lg:col-span-6",
    link: "/ipiresies/psixologos-patra-yperfagia",
  },
  {
    icon: Users,
    title: "Σχέσεις & Δεσμός",
    desc: "Ενίσχυση επικοινωνίας, διαχείριση συγκρούσεων και κατανόηση των μοτίβων δεσμού στις σημαντικές σου σχέσεις.",
    span: "md:col-span-12 lg:col-span-6",
    link: "/ipiresies/psixologos-patra-sxeseis",
  },
  {
    icon: Heart,
    title: "Αυτοεκτίμηση & Αίσθηση Αξίας",
    desc: "Δουλεύουμε πάνω στην εικόνα του εαυτού, την αυτοπεποίθηση και τα εσωτερικά μοτίβα που επηρεάζουν τις επιλογές και τις σχέσεις σου — η ουσία του «psyloveyourself».",
    span: "md:col-span-12 lg:col-span-6",
    link: "/ipiresies/psixologos-patra-aftoektimisi",
  },
  {
    icon: GraduationCap,
    title: "Ψυχοθεραπεία Εφήβων",
    desc: "Υποστήριξη στους εφήβους σε θέματα ταυτότητας, σχέσεων, σχολείου και συναισθηματικής διαχείρισης, μέσα σε ένα ασφαλές και αμερόληπτο πλαίσιο.",
    span: "md:col-span-12 lg:col-span-4",
    link: "/ipiresies/psixologos-patra-efivoi",
  },
  {
    icon: HeartHandshake,
    title: "Ψυχοθεραπεία Ζεύγους",
    desc: "Δουλειά πάνω στην επικοινωνία, τις προσδοκίες και τη συναισθηματική σύνδεση μέσα στη σχέση, με στόχο την κατανόηση και την ανανέωση του δεσμού.",
    span: "md:col-span-12 lg:col-span-4",
    link: "/ipiresies/psixologos-patra-zeugous",
  },
  {
    icon: Sprout,
    title: "Συμβουλευτική Γονέων",
    desc: "Πρακτική και θεραπευτική υποστήριξη σε γονείς για ζητήματα ορίων, ανατροφής, επικοινωνίας με τα παιδιά και διαχείρισης δύσκολων φάσεων.",
    span: "md:col-span-12 lg:col-span-4",
    link: "/ipiresies/psixologos-patra-symvouleftiki-goneon",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 sm:py-32 bg-card/40 relative"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 lg:mb-20 items-end">
          <motion.div {...fadeUp} className="lg:col-span-7">
            <p className="text-[11px] tracking-[0.25em] uppercase font-body font-medium text-primary mb-5">
              Υπηρεσίες
            </p>
            <h2
              data-testid="services-heading"
              className="font-heading font-medium tracking-tight text-foreground text-4xl sm:text-5xl lg:text-[60px] leading-[1.05]"
            >
              Πώς μπορώ <span className="italic font-light">να σε βοηθήσω.</span>
            </h2>
          </motion.div>
          <motion.p
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.1 }}
            className="lg:col-span-5 text-lg font-body font-light text-foreground/70 leading-relaxed"
          >
            Κάθε συνεδρία προσαρμόζεται στις δικές σου ανάγκες. Παρακάτω
            βρίσκονται οι θεματικές γύρω από τις οποίες δουλεύω συχνότερα.
          </motion.p>
        </div>

        <motion.div
          {...stagger(0.06)}
          className="grid grid-cols-1 lg:grid-cols-12 gap-5 sm:gap-6"
        >
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.title}
                variants={{
                  initial: { opacity: 0, y: 30 },
                  whileInView: {
                    opacity: 1,
                    y: 0,
                    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
                  },
                }}
                data-testid={`service-card-${i}`}
                className={`group relative ${s.span} bg-background border border-border/60 rounded-3xl p-8 sm:p-10 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_60px_rgb(42,54,46,0.06)] overflow-hidden`}
              >
                {s.big && s.img && (
                  <div className="absolute inset-0 -z-10 opacity-[0.16]">
                    <img
                      src={s.img}
                      alt=""
                      loading="lazy"
                      aria-hidden="true"
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-transparent" />
                  </div>
                )}
                <div className="flex items-start justify-between mb-6">
                  <div
                    className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center text-primary"
                    aria-hidden="true"
                  >
                    <Icon size={22} strokeWidth={1.5} />
                  </div>
                  <span className="font-heading italic text-muted-foreground/60 text-base">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3
                  className={`font-heading font-medium text-foreground tracking-tight ${
                    s.big
                      ? "text-3xl sm:text-4xl lg:text-[44px] leading-[1.05]"
                      : "text-2xl sm:text-[26px] leading-tight"
                  }`}
                >
                  {s.title}
                </h3>
                <p
                  className={`mt-4 font-body font-light text-foreground/70 leading-relaxed ${
                    s.big ? "text-lg max-w-[520px]" : "text-base"
                  }`}
                >
                  {s.desc}
                </p>
                {s.link && (
                  <Link
                    to={s.link}
                    data-testid={`service-link-${i}`}
                    className="mt-5 inline-flex items-center gap-1.5 text-sm font-body text-foreground/85 hover:text-primary transition-colors"
                  >
                    Δες περισσότερα
                    <ArrowUpRight
                      size={14}
                      strokeWidth={1.5}
                      className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    />
                  </Link>
                )}
              </motion.article>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
